<template>
  <div class="header">
      <span class="go-back el-icon-back" @click="goBack">
      </span>
      <div>
        <span class="name">
          {{title}}
        </span>
        <span
          v-if="type=== 'device'"
         :class="['status',btnState.class]">
        {{btnState.text}}
         </span>
      </div>
    </div>
</template>
<script>
export default {
  props: ['detail', 'type'],
  data () {
    return {
      title: '',
      btnState: {
        class: '',
        text: ''
      }
    }
  },
  methods: {
    goBack () {
      window.history.go(-1)
    },
    initData () {
      // type用于表示不同的标题类型，devcie表示设备模块的头部
    // deviceStatus
    /** ONLINE：在线。0
      OFFLINE：离线。1
      UNACTIVE：未激活。2
      DISABLE：已禁用。3 */
      if (this.type === 'device' && this.detail.deviceName) {
        this.title = this.detail.deviceName ? this.detail.deviceName : this.detail.nickName
        const stateParams = {
          0: 'ONLINE',
          1: 'OFFLINE',
          2: 'UNACTIVE',
          3: 'DISABLE'
        }
        const classParams = {
          0: 'online',
          1: 'offline',
          2: 'inactive',
          3: 'disabled'
        }
        try {
          const key = this.detail.deviceStatus.toString()
          this.btnState = { text: stateParams[key], class: classParams[key] }
        } catch (e) {}
      } else if (this.type === 'certificate') {
        this.title = this.detail.title
      }
    }
  },
  created () {
    console.log('获取的detail888888：', this.detail)
    this.initData()
  },
  watch: {
    detail () {
      console.log('detail变化了:', this.detail)
      this.initData()
    }
  }
}
</script>
<style lang="less" scoped>
.header{
    display: flex;
    align-items: center;
    margin-bottom: 14px;
    position: relative;
    .go-back{
      cursor: pointer;
    }
    .el-icon-back{
      font-size: 20px;
      font-weight: bold;
      width: 25px;
    }
    .el-col{
      display: flex;
      align-items: center;
    }
    .el-col-5{
      display: flex;
      align-items: center;
    }
    .name{
      margin-left: 20px;
      font-size: 28px;
      font-weight: bold;
    }
    .status{
      // font-weight: normal;
      // font-size: 12px;
      // padding: 2px 8px;
      // border-radius: 15px;
      // margin-left: 8px;
      // display: inline-block;
        font-size: 12px;
        padding: 2px 8px;
        border-radius: 15px;
        margin-left: 8px;
        display: inline-block;
        line-height: 20px;
        position: absolute;
        transform: translateY(-50%);
        top: 50%;
    }
    .disabled{
      background: #f7eded!important;
        color: #996262!important;
    }
    .inactive{
      background: #f7f6ed!important;
      color: #999062!important;
    }
    .offline{
       background:#f7f7f7 !important;
        color: #888888!important;
    }
    .online{
      background: #edfcf1 !important;
      color: #1E8E39 !important;
    }

  }
</style>
